import { fetchCustomers, fetchCustomerSubscriptions, addTime, deductTime, ApiError, } from '../../../api/adminApi';
import { t, createScreenHeader, createBackButton, createCustomerField, createSubscriptionsTable, isUnauthorized, } from './context';
export function showRemainingHoursScreen(ctx) {
    ctx.screen.innerHTML = '';
    const header = createScreenHeader(t('admin.remainingHours.title'));
    const content = document.createElement('div');
    content.className = 'admin__content admin__form';
    content.textContent = t('admin.remainingHours.loading');
    const backButton = createBackButton(ctx, t('admin.remainingHours.back'));
    ctx.screen.append(header, content, backButton);
    fetchCustomers()
        .then((customers) => {
        renderRemainingHoursContent(ctx, content, customers);
    })
        .catch((err) => {
        if (isUnauthorized(err)) {
            ctx.showLogin();
            return;
        }
        console.error('Failed to load customers:', err);
        content.textContent = t('admin.remainingHours.loadError');
    });
}
function renderRemainingHoursContent(ctx, content, customers) {
    content.innerHTML = '';
    const { wrapper: customerWrapper, select: customerSelect } = createCustomerField(t('admin.remainingHours.customerLabel'), t('admin.remainingHours.customerPlaceholder'), customers);
    const showButton = document.createElement('button');
    showButton.type = 'button';
    showButton.className = 'cta admin__submit';
    showButton.textContent = t('admin.remainingHours.showButton');
    showButton.disabled = true;
    // Results table (or empty / error message) is rendered here on demand.
    const results = document.createElement('div');
    results.className = 'admin__remaining-results';
    content.append(customerWrapper, showButton, results);
    customerSelect.addEventListener('change', () => {
        showButton.disabled = !customerSelect.value;
        // Selecting a different customer invalidates the currently shown table.
        results.innerHTML = '';
    });
    showButton.addEventListener('click', () => {
        const customer = customers.find((c) => c.id === Number(customerSelect.value));
        if (!customer)
            return;
        loadSubscriptions(ctx, results, customer);
    });
}
function loadSubscriptions(ctx, results, customer) {
    results.innerHTML = '';
    results.textContent = t('admin.remainingHours.loading');
    fetchCustomerSubscriptions(customer.id)
        .then((subscriptions) => {
        renderSubscriptionsTable(ctx, results, customer, subscriptions);
    })
        .catch((err) => {
        if (isUnauthorized(err)) {
            ctx.showLogin();
            return;
        }
        console.error('Failed to load customer subscriptions:', err);
        results.innerHTML = '';
        results.textContent = t('admin.remainingHours.subscriptionsLoadError');
    });
}
function renderSubscriptionsTable(ctx, results, customer, subscriptions) {
    results.innerHTML = '';
    results.appendChild(createSubscriptionsTable(subscriptions, {
        emptyText: t('admin.remainingHours.empty'),
        subscriptionHeader: t('admin.remainingHours.table.subscription'),
        timeLeftHeader: t('admin.remainingHours.table.timeLeft'),
        subscriptionLabel: (sub) => t('admin.remainingHours.subscriptionLabel', { plan: sub.planName, place: sub.placeTypeName }),
        extraColumn: {
            header: t('admin.remainingHours.table.action'),
            cell: (sub) => {
                const actionCell = document.createElement('td');
                const actionLink = document.createElement('button');
                actionLink.type = 'button';
                actionLink.className = 'admin__table-edit';
                actionLink.textContent = t('admin.remainingHours.actionButton');
                actionLink.addEventListener('click', () => {
                    openAddOrDeductModal(ctx, customer, sub, () => loadSubscriptions(ctx, results, customer));
                });
                actionCell.appendChild(actionLink);
                return actionCell;
            },
        },
    }));
}
function openAddOrDeductModal(ctx, customer, sub, onChanged) {
    const overlay = document.createElement('div');
    overlay.className = 'admin__modal-overlay';
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay)
            overlay.remove();
    });
    const modal = document.createElement('div');
    modal.className = 'admin__modal';
    const title = document.createElement('h2');
    title.className = 'admin__modal-title';
    title.textContent = t('admin.remainingHours.modal.title');
    const form = document.createElement('div');
    form.className = 'admin__form';
    const field = document.createElement('label');
    field.className = 'admin__field';
    const fieldLabel = document.createElement('span');
    fieldLabel.className = 'admin__field-label';
    fieldLabel.textContent = t('admin.remainingHours.modal.minutesLabel');
    const input = document.createElement('input');
    input.className = 'admin__input';
    input.type = 'number';
    input.min = '1';
    input.step = '1';
    field.append(fieldLabel, input);
    const error = document.createElement('p');
    error.className = 'admin__error';
    error.hidden = true;
    const actions = document.createElement('div');
    actions.className = 'admin__modal-confirm-actions';
    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.className = 'cta admin__submit';
    cancelButton.textContent = t('admin.remainingHours.modal.cancel');
    cancelButton.addEventListener('click', () => overlay.remove());
    const addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'cta admin__submit';
    addButton.textContent = t('admin.remainingHours.modal.add');
    addButton.addEventListener('click', () => {
        const minutes = Number(input.value);
        if (!Number.isInteger(minutes) || minutes <= 0) {
            error.textContent = t('admin.remainingHours.modal.validationError');
            error.hidden = false;
            return;
        }
        error.hidden = true;
        openConfirmModal(ctx, customer, sub, minutes, 'add', () => {
            overlay.remove();
            onChanged();
        });
    });
    const deductButton = document.createElement('button');
    deductButton.type = 'button';
    deductButton.className = 'cta admin__submit';
    deductButton.textContent = t('admin.remainingHours.modal.deduct');
    deductButton.addEventListener('click', () => {
        const minutes = Number(input.value);
        if (!Number.isInteger(minutes) || minutes <= 0) {
            error.textContent = t('admin.remainingHours.modal.validationError');
            error.hidden = false;
            return;
        }
        error.hidden = true;
        openConfirmModal(ctx, customer, sub, minutes, 'deduct', () => {
            overlay.remove();
            onChanged();
        });
    });
    actions.append(cancelButton, addButton, deductButton);
    form.append(field, error, actions);
    modal.append(title, form);
    overlay.appendChild(modal);
    ctx.section.appendChild(overlay);
}
function openConfirmModal(ctx, customer, sub, minutes, action, onConfirmed) {
    const overlay = document.createElement('div');
    overlay.className = 'admin__modal-overlay';
    overlay.addEventListener('click', (event) => {
        if (event.target === overlay)
            overlay.remove();
    });
    const modal = document.createElement('div');
    modal.className = 'admin__modal admin__modal--confirm';
    const text = document.createElement('p');
    text.className = 'admin__modal-confirm-text';
    const name = `${customer.surname} ${customer.name}`;
    text.textContent =
        action === 'add'
            ? t('admin.remainingHours.confirm.addText', { minutes, name })
            : t('admin.remainingHours.confirm.deductText', { minutes, name });
    const error = document.createElement('p');
    error.className = 'admin__error';
    error.hidden = true;
    const actions = document.createElement('div');
    actions.className = 'admin__modal-confirm-actions';
    const noButton = document.createElement('button');
    noButton.type = 'button';
    noButton.className = 'cta admin__submit';
    noButton.textContent = t('admin.remainingHours.confirm.no');
    noButton.addEventListener('click', () => overlay.remove());
    const yesButton = document.createElement('button');
    yesButton.type = 'button';
    yesButton.className = 'cta admin__submit';
    yesButton.textContent = t('admin.remainingHours.confirm.yes');
    yesButton.addEventListener('click', () => {
        error.hidden = true;
        yesButton.disabled = true;
        noButton.disabled = true;
        yesButton.classList.add('is-loading');
        const request = action === 'add' ? addTime(customer.id, sub.id, minutes) : deductTime(customer.id, sub.id, minutes);
        request
            .then(() => {
            overlay.remove();
            onConfirmed();
        })
            .catch((err) => {
            if (isUnauthorized(err)) {
                overlay.remove();
                ctx.showLogin();
                return;
            }
            console.error(`Failed to ${action} time:`, err);
            error.textContent =
                action === 'deduct' && err instanceof ApiError && err.code === 'insufficient_balance'
                    ? t('admin.remainingHours.confirm.insufficientError')
                    : err instanceof ApiError
                        ? t(action === 'add'
                            ? 'admin.remainingHours.confirm.addSubmitError'
                            : 'admin.remainingHours.confirm.deductSubmitError')
                        : t('admin.remainingHours.confirm.genericError');
            error.hidden = false;
            yesButton.disabled = false;
            noButton.disabled = false;
            yesButton.classList.remove('is-loading');
        });
    });
    actions.append(noButton, yesButton);
    modal.append(text, error, actions);
    overlay.appendChild(modal);
    ctx.section.appendChild(overlay);
}
